import { Stack, styled, Typography } from "@mui/material";

export const ContainerStack = styled(Stack)({
    margin: "16px -16px",
    padding: "16px 16px",
    backgroundImage:
        "linear-gradient(to right bottom, #0056b8, #007cd1, #009dd3, #00bac3, #1dd4ad)",
    gap: "16px",
});

export const SectionTitle = styled(Typography)({
    fontSize: "1.25rem",
    fontWeight: 400,
    color: "var(--community-color-snow-white)",
});
